import { Skeleton } from "@/components/shared/Skeleton";
import { THUMBNAIL } from "@/lib/constants/shared";
import { CANVAS_SIZE } from "@/lib/constants/slides";
import { Card } from "@ai-teach/ui-web";

interface SlideCardSkeletonProps {
  slideNumber?: number;
}

export function SlideCardSkeleton({ slideNumber }: SlideCardSkeletonProps) {
  return (
    <div className="flex flex-col">
      {/* Slide number */}
      <span className="text-sm font-semibold text-gray-400 mb-2">{slideNumber ?? "–"}</span>

      <Card className="relative overflow-hidden">
        {/* Thumbnail */}
        <Skeleton
          className={`${CANVAS_SIZE.freeform.aspectRatioClass} w-full rounded-t-lg border-b border-slate-200`}
        />

        {/* Bottom content */}
        <div className="p-4 pt-5 space-y-3.5">
          {/* Title (2 lines) */}
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />

          {/* Type */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-7 w-24 rounded-md bg-gray-700" />
          </div>

          {/* Knowledge area */}
          <div className="space-y-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-10 w-full rounded-md bg-gray-700" />
          </div>

          {/* Warning / status section (fixed height) */}
          <div className="relative p-3 rounded-lg border border-slate-200 bg-gray-700 space-y-2">
            <Skeleton className="w-32 h-[47px]" />
            <Skeleton className="h-4 w-full" />
          </div>

          {/* Linked Copies section */}
          <div className="py-5 px-3 space-y-1.5 border rounded-lg">
            <Skeleton className="h-4 w-3/4 bg-gray-700" />
            <Skeleton className="h-3 w-1/2 bg-gray-700" />
          </div>
        </div>
      </Card>
    </div>
  );
}
